import { makeStyles, createStyles, Button, Grid } from "@material-ui/core";
import notFound from "../../images/notFound.svg";
import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet-async";

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      textTransform: "none",
      border: "2px solid #890608",
      borderRadius: 4,
      textDecoration: "none",
      padding: "9px 14px",
      marginTop: 20,
    },
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: 50,
      textAlign: "center",
    },
    margin: {
      margin: "20px 0",
    },
    buttonsContainer: {
      marginTop: 40,
    },
    buttonGridItem: {
      margin: 10,
    },
  })
);

export const NotFound = () => {
  const classes = useStyles();
  const { t } = useTranslation<'common'>();

  return (

    <>
            <Helmet>
                <title>404 - Page Not Found</title>
                <meta name="description" content={t("notFound.page_not_found_message")} />
                <meta name="robots" content="noindex, follow" />
                <link rel="canonical" href="https://afriqpnb.com/404" />
                <meta property="og:title" content="404 - Page Not Found" />
                <meta property="og:description" content={t("notFound.page_not_found_message")} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://afriqpnb.com/404" />
                <meta property="og:image" content="https://example.com/path-to-your-404-image.jpg" />
            </Helmet>

            <div className={classes.root}>
                <img src={notFound} alt="404 - Page Not Found" width={400} />
                <h1 className={classes.margin}>{t("notFound.page_not_found")}</h1>
                <h2 className={classes.margin}>{t("notFound.page_not_found_message")}</h2>
                <Grid container justify="center" className={classes.buttonsContainer}>
                <Grid item className={classes.buttonGridItem}>
                    <Button
                    variant="outlined"
                    href="/"
                    className={classes.button}
                    >
                    {t("notFound.apartments")} 
                    </Button>
                </Grid>
                <Grid item className={classes.buttonGridItem}>
                    <Button
                    variant="outlined"
                    href="/hotels"
                    className={classes.button}
                    >
                    {t("notFound.hotels")} 
                    </Button>
                </Grid>
                <Grid item className={classes.buttonGridItem}>
                    <Button
                    variant="outlined"
                    href="/voitures"
                    className={classes.button}
                    >
                    {t("notFound.cars")} 
                    </Button>
                </Grid>
                <Grid item className={classes.buttonGridItem}>
                    <Button
                    variant="outlined"
                    href="/restaurants-activites"
                    className={classes.button}
                    >
                    {t("notFound.tours")} 
                    </Button>
                </Grid>
                <Grid item className={classes.buttonGridItem}>
                    <Button
                    variant="outlined"
                    href="/immobilier"
                    className={classes.button}
                    >
                    {t("notFound.real_estate")} 
                    </Button>
                </Grid>
                <Grid item className={classes.buttonGridItem}>
                    <Button
                    variant="outlined"
                    href="/evenements"
                    className={classes.button}
                    >
                    {t("notFound.events")} 
                    </Button>
                </Grid>
                <Grid item className={classes.buttonGridItem}>
                    <Button
                    variant="outlined"
                    href="/blog"
                    className={classes.button}
                    >
                    {t("notFound.blog")} 
                    </Button>
                </Grid>
                <Grid item className={classes.buttonGridItem}>
                    <Button
                    variant="outlined"
                    href="/guide-touristique"
                    className={classes.button}
                    >
                    {t("notFound.tourist_guides")} 
                    </Button>
                </Grid>
                </Grid>
                <a href="/" className={classes.button}>
                {t("notFound.go_back_home")}
                </a>
            </div>
        </>
        );
    };
